import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import { ConnectedRouter } from "./redux/ConnectedRouter";
import { store, history } from './redux/store';
import { Root } from './Root';
import registerServiceWorker from './registerServiceWorker';
import {translations} from "./translations/translations";
import I18n from "redux-i18n";
import './index.scss';

// Include this to the build
require('./assets/images/Obelux-logo__white.svg');

ReactDOM.render(

  <Provider store={store}>
    <I18n translations={translations} initialLang="en">
      <ConnectedRouter history={history}>
        <Root/>
      </ConnectedRouter>
      <div id="modal"/>
    </I18n>
  </Provider>,
  document.getElementById('root'));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js